import { render, staticRenderFns } from "./amount-input.vue?vue&type=template&id=f6bf8518"
import script from "./amount-input.vue?vue&type=script&lang=js"
export * from "./amount-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports